import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { productWarehouseHistoryService } from 'features/inventory/warehouses/api/product-warehouse-history.service';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { WarehouseProductsHistoryLineColumns } from './product-warehouse-history-line';

export const HistoryList = () => {
  const translationPrefix = 'pages.history';
  const datagridRefresh = useRef(null);

  const { t } = useTranslation();

  const columns: GridColDef[] = WarehouseProductsHistoryLineColumns(datagridRefresh);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={productWarehouseHistoryService}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
};

export default HistoryList;
